var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"fullPic",style:({backgroundImage:'url(' +'\''+ _vm.pic +'\''+ ')', backgroundRepeat:'no-repeat'}),attrs:{"id":"fullPic"}},[(_vm.link)?_c('div',{staticClass:"link",on:{"click":_vm.goLink}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d534f56","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/comment/tbChildPage/fullPic.vue
// module id = null
// module chunks = 